import { lazy, Suspense } from 'react';
import { Route, Router, Switch } from 'wouter';
import { Spinner } from './components/loading/Spinner';
import { MAX_UTIL_URL } from './config';

const Home = lazy(() => import('./app/page'));
const UpcomingPage = lazy(() => import('./app/upcoming/page'));
const TradingPage = lazy(() => import('./app/trading/page'));
const TradingMemePage = lazy(() => import('./app/trading-meme/page'));
const DefaiTradingPage = lazy(() => import('./app/trading-defai/page'));
const CreateToken = lazy(() => import('./app/create-coin/page'));
const MemePage = lazy(() => import('./app/meme/page'));
const ProfilePage = lazy(() => import('./app/profile/page'));
const StrongBoxVault = lazy(() => import('./app/strongbox-vault/page'));
const MaxUtilities = lazy(() => import('./app/max-utilities/page'));

export function Routes() {
  return (
    <Suspense
      fallback={
        <div
          id="loader-fallback"
          style={{
            height: '100vh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Spinner />
        </div>
      }
    >
      <Router>
        <Switch>
          <Route path="/meme" component={MemePage} />
          <Route path="/create-coin" component={CreateToken} />
          <Route path="/vaults" component={StrongBoxVault} />
          <Route path={MAX_UTIL_URL} component={MaxUtilities} />
          <Route path="/profile/:address" component={ProfilePage} />
          <Route path="/upcoming/:address" component={UpcomingPage} />
          <Route path="/trading/:address" component={TradingPage} />
          <Route path="/trading-meme/:address" component={TradingMemePage} />
          <Route path="/trading-defai/:address" component={DefaiTradingPage} />
          <Route path="/" component={Home} />
        </Switch>
      </Router>
    </Suspense>
  );
}
